<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('tokens')"
      :columns="columns"
      :column_search="true"
      resource_url="/renap/token/datatables"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
    </generic-table>
    <token-modal ref="token_modal" @success="refresh" />
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_currency,
  format_date_time,
} from "@/utils";
import { truncate } from "lodash";
import TokenModal from "../token_modal/Index.vue";

export default {
  name: "TokenDatatable",
  components: { GenericTable, TokenModal },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("profile"),
          data: (row) => {
            return row.profile.name;
          },
        },
        {
          title: v.$t("expire date"),
          data: (row) => {
            return format_date_time(row.expire_date);
          },
        },
        {
          title: v.$t("token"),
          searchable: false,
          // width: "80%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return truncate(row.token, 50);
          },
        },
        {
          title: v.$t("options"),
          // width: "20%",
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("view"),
                icon: "fa fa-eye",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.token_modal.view_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete token?"),
                    v,
                    () => {
                      del("/renap/token", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    format_currency,
    create() {
      let v = this;
      v.$refs.token_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
